import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/api";
export class SnackbarService {
  messageService;
  _key = 'SNACKBAR';
  constructor(messageService) {
    this.messageService = messageService;
  }
  get key() {
    return this._key;
  }
  add(message) {
    const {
      severity,
      summary,
      detail
    } = message;
    const life = 4000; //<!-- life is duration in Milliseconds -->
    const closable = false;
    this.messageService.add({
      key: this.key,
      severity: severity,
      summary,
      detail,
      life,
      closable
    });
  }
  clear() {
    this.messageService.clear();
  }
  static ɵfac = function SnackbarService_Factory(t) {
    return new (t || SnackbarService)(i0.ɵɵinject(i1.MessageService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnackbarService,
    factory: SnackbarService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SnackbarService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.MessageService
  }], null);
})();
